import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import PropTypes from 'prop-types';

const transition = { duration: 0.4 };
const variants = {
  initial: { opacity: 0, height: 0 },
  animate: { opacity: 1, height: 'auto' },
  exit: { opacity: 0, height: 0 },
};

const AnimatedSwitcher = ({
  items,
  displayedKey,
  motionProps,
}) => {
  const current = items.find(item => item.key === displayedKey) || items[0];

  return (
    <AnimatePresence mode='wait'>
      {current && (
        <motion.div
          key={current.key}
          initial={current.key === items[0].key ? false : variants.initial}
          animate={variants.animate}
          exit={variants.exit}
          transition={transition}
          style={{ overflow: 'hidden' }}
          {...motionProps}
        >
          {typeof current.component === 'function'
            ? React.createElement(current.component)
            : current.component}
        </motion.div>
      )}
    </AnimatePresence>
  );
};

AnimatedSwitcher.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      component: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
    })
  ).isRequired,
  displayedKey: PropTypes.string,
  motionProps: PropTypes.object,
};

export default AnimatedSwitcher;

